import { createSlice } from '@reduxjs/toolkit';

const initialState = { billingHistory: null };

const billingHistorySlice = createSlice({
  name: 'billingHistory',
  initialState,
  reducers: {
    billingHistoryHandler(state, action) {
      state.billingHistory = action.payload.billingHistoryData;
    },
    resetBillingHistory(state) {
      state.billingHistory = null;
    },
  },
});
export const billingHistoryAction = billingHistorySlice.actions;
export default billingHistorySlice;